import useSEO from "../../../utils/seo";
import Container from "../../../utils/Container";
import Hero from "./components/Hero";
import HotelSearch from "../../../utils/HotelSearch";
import CustomizedSection from "./components/CustomizedSection";
import { useEffect, useState } from "react";
import { showAllHotel } from "../../../api/website/hotel/hotelApi";
import Banner from "../../../assets/banner/login.jpg";
import PopUp from "./components/sections/PopUp";
const Home = () => {
  const [Data, setData] = useState([]);

  useEffect(() => {
    showAllHotel(setData);
  }, []);
  useSEO({
    title: "Dhoorbin.com - Your world of Travel, Just One Click Away!",
    description:
      "Your travel companion for booking hotels, tours, and experiences worldwide.",
    image: `${window.location.origin}/images/banner.png`,
    url: "https://dhoorbin.com",
    canonical: "https://dhoorbin.com",
    keywords: "travel, hotel, tour, booking",
    publisher: "Dhoorbin",
    robots: "index, follow",
    lang: "en",
  });
  return (
    <>
      {/* <PopUp /> */}
      <div className="py-3">
        <Container>
          <div className="relative block lg:grid grid-cols-3">
            <div className="col-span-2">
              <Hero Data={Data} />
            </div>
            <div>
              <HotelSearch />
            </div>
          </div>
          <div className="pt-10">
            <CustomizedSection Data={Data} />
          </div>
        </Container>
      </div>
    </>
  );
};

export default Home;
